import { AxiosResponse } from 'axios'
import { Toastr } from 'components/global/Toastr'
import { Action } from 'types/redux'
import { handleResponseErr } from 'utils/apiHelperUtils'
import * as actions from './actions'
import { GetJobOverViewReponse } from './types'

type InitialStateType = {
  fetching: boolean
  total_job: number
  open_job: number
  close_job: number
  hired_candidates: number
  open_job_with_no_hired_candidates: number
  close_job_with_no_hired_candidates: number
  job_created_this_month: number
}

const initialState: InitialStateType = {
  fetching: false,
  total_job: 0,
  open_job: 0,
  close_job: 0,
  hired_candidates: 0,
  open_job_with_no_hired_candidates: 0,
  close_job_with_no_hired_candidates: 0,
  job_created_this_month: 0,
}

export default function reducer(
  state = initialState,
  action: Action<AxiosResponse<GetJobOverViewReponse>>,
): InitialStateType {
  switch (action.type) {
    case actions.GET_JOB_OVERVIEW_PENDING: {
      return {
        ...state,
        fetching: true,
      }
    }

    case actions.GET_JOB_OVERVIEW_FULFILLED: {
      return {
        ...state,
        ...action.payload?.data.data,
        fetching: false,
      }
    }

    case actions.GET_JOB_OVERVIEW_REJECTED: {
      if (action.payload) {
        Toastr.error(handleResponseErr({ response: action.payload }))
      }
      return {
        ...state,
        fetching: false,
      }
    }
    default:
      return state
  }
}
